import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M14.5 4.00037H6.5L5.7 8.87537H15.3L14.5 4.00037ZM2.5 10.5004C2.5 10.5004 4.1 11.3129 10.5 11.3129C16.9 11.3129 18.5 10.5004 18.5 10.5004L15.3 8.87537H5.7L2.5 10.5004ZM8.9 13.7504H12.1V14.5629H8.9V13.7504Z" 
      fill="currentColor"
    />
    <path 
      d="M7.3 17.0004C8.62548 17.0004 9.7 15.9091 9.7 14.5629C9.7 13.2167 8.62548 12.1254 7.3 12.1254C5.97452 12.1254 4.9 13.2167 4.9 14.5629C4.9 15.9091 5.97452 17.0004 7.3 17.0004Z" 
      fill="currentColor"
    />
    <path 
      d="M13.7 17.0004C15.0255 17.0004 16.1 15.9091 16.1 14.5629C16.1 13.2167 15.0255 12.1254 13.7 12.1254C12.3745 12.1254 11.3 13.2167 11.3 14.5629C11.3 15.9091 12.3745 17.0004 13.7 17.0004Z" 
      fill="currentColor"
    />
  </svg>
);
